import styled from 'styled-components';

export const STableCell = styled.td<{ textAlign: 'left' | 'right' | 'center' }>`
  text-align: ${({ textAlign }) => textAlign};
`;
